import {
  CreateInclusionInterface,
  InclusionInterface,
  QueryInclusionInterface,
  UpdateInclusionInterface,
} from "@/types/InclusionInterface";
import axiosClient from ".";

export default {
  async createInclusion(
    params: CreateInclusionInterface
  ): Promise<InclusionInterface> {
    return axiosClient
      .post("inclusion", params)
      .then((res) => res.data)
      .catch((err) => Promise.reject(err));
  },

  async getInclusionsByQuery(
    params: QueryInclusionInterface
  ): Promise<InclusionInterface[]> {
    return axiosClient
      .get("inclusion", { params })
      .then((res) => res.data)
      .catch((err) => Promise.reject(err));
  },

  async updateInclusion(
    dto: UpdateInclusionInterface,
    id: string
  ): Promise<void> {
    return axiosClient
      .patch(`inclusion/${id}`, dto)
      .then((res) => res.data)
      .catch((err) => Promise.reject(err));
  },

  async deleteInclusion(id: string): Promise<void> {
    return axiosClient
      .delete(`inclusion/${id}`)
      .then((res) => res.data)
      .catch((err) => Promise.reject(err));
  },

  async uploadImageInclusion(builderId: string, image: FormData) : Promise<{
    Location: string;
    Key: string;
    format: string;
    updatedAt: string;
  }> {
    return axiosClient.post(`inclusion/images/${builderId}`, image)
           .then((res) => res.data)
           .catch((err) => Promise.reject(err));
  },
};
